import { Helmet } from 'react-helmet';
import Footer from '../../components/dark/modern-startup/Footer';
import Header from '../../components/dark/about2/Header';
import Lines from '../../components/dark/common/Lines';
import ProgressScroll from '../../components/dark/common/ProgressScroll';
import Cursor from '../../components/dark/common/cusor';
import LoadingScreen from '../../components/dark/common/loader';
import Navbar from '../../components/dark/modern-startup/Navbar';
import Intro from '../../components/dark/about2/Intro';
import Marquee from '../../components/dark/about2/Marquee';
import Testimonials from '../../components/dark/about/Testimonials';
import Team from '../../components/dark/about/Team';
import Numbers from '../../components/dark/about2/Numbers';
import About from '../../components/dark/about2/About';
import Brands from '../../components/dark/about2/Brands';
import Services from '../../components/dark/about2/Services';
import React from 'react';
export default function PageAbout2() {
  return (
    <>
      <Helmet>
        <title>Step In Home Services | Professional Cleaning & Maintenance in Bengaluru and Mysuru</title>
        <link rel="icon" href="/dark/assets/imgs/favicon.png" />
        <link rel="shortcut icon" href="/dark/assets/imgs/favicon.png" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/dark/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/dark/assets/js/scripts.js"></script>
        <script src="/dark/assets/js/smoother-script.js"></script>
      </Helmet>
      {/* <body> */}
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <Intro />
              <Numbers />
              <About />
              <Marquee />
              <Brands />
              <Services />
              <Testimonials />
              <Team />
            
            </main>
            <Footer />
          </div>
        </div>
      {/* </body> */}
    </>
  );
}
